import { usePatchPropertyArtMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyArtMutation";
import { usePatchPropertyCottageMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyCottageMutation";
import { usePatchPropertyFlatMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyFlatMutation";
import { usePatchPropertyHouseMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyHouseMutation";
import { usePatchPropertyLandMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyLandMutation";
import { usePatchPropertyVehicleMutation } from "web_myplann/Api/Portfolio/Mutations/usePatchPropertyVehicleMutation";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";

type PropertyValueMutation = {
	save: (value: number, onSuccess: () => void) => void;
	isPending: boolean;
};

export const usePropertyValueMutation = (
	propertyId: number,
	type: ClientPropertyTypeEnum,
): PropertyValueMutation => {
	const house = usePatchPropertyHouseMutation(propertyId);
	const flat = usePatchPropertyFlatMutation(propertyId);
	const cottage = usePatchPropertyCottageMutation(propertyId);
	const land = usePatchPropertyLandMutation(propertyId);
	const vehicle = usePatchPropertyVehicleMutation(propertyId);
	const art = usePatchPropertyArtMutation(propertyId);

	switch (type) {
		case ClientPropertyTypeEnum.House:
			return {
				save: (value, onSuccess) =>
					house.mutate({ marketValue: value }, { onSuccess }),
				isPending: house.isPending,
			};
		case ClientPropertyTypeEnum.Flat:
			return {
				save: (value, onSuccess) =>
					flat.mutate({ marketValue: value }, { onSuccess }),
				isPending: flat.isPending,
			};
		case ClientPropertyTypeEnum.Cottage:
			return {
				save: (value, onSuccess) =>
					cottage.mutate({ marketValue: value }, { onSuccess }),
				isPending: cottage.isPending,
			};
		case ClientPropertyTypeEnum.Land:
			return {
				save: (value, onSuccess) =>
					land.mutate({ landValue: value }, { onSuccess }),
				isPending: land.isPending,
			};
		case ClientPropertyTypeEnum.AutoMoto:
			return {
				save: (value, onSuccess) => vehicle.mutate({ value }, { onSuccess }),
				isPending: vehicle.isPending,
			};
		case ClientPropertyTypeEnum.Art:
			return {
				save: (value, onSuccess) => art.mutate({ value }, { onSuccess }),
				isPending: art.isPending,
			};
		default:
			return {
				save: () => undefined,
				isPending: false,
			};
	}
};
